import InfoCircleSvg from 'components/_common/Icons/SVGIcons/InfoCircleSvg';
import TooltipOverlay from 'components/UI/TooltipOverlay';
import { type PropsWithChildren } from 'react';
import { Col, Row } from 'react-bootstrap';

import type { PageBreadcrumbItem } from '../PageBreadcrumb';

interface PageHeaderProps {
  title: string;
  count?: number;
  description?: string | undefined;
  breadcrumbs?: PageBreadcrumbItem[] | undefined;
  showCount?: boolean;
  buttonHTML?: any;
  rightSection?: any;
  tooltipText?: string;
  // extra class on the wrapper, for page-specific header tweaks
  className?: string;
}
export default function PageHeader({
  title,
  count = 0,
  description,
  children,
  showCount = true,
  buttonHTML,
  rightSection,
  tooltipText = '',
  className,
}: PropsWithChildren<PageHeaderProps>) {
  return (
    <div className={`page-header ${className ?? ''}`}>
      {/* <div className='col-12'></div> */}
      <Row className="align-items-center justify-content-between g-2">
        <Col xs={12} sm={rightSection ? 6 : 12}>
          <Row className="g-4 page-title">
            <Row className="float-start">
              <Col xs={12} xxl={12}>
                <span className="float-start page-name">
                  {buttonHTML ? buttonHTML : ''}
                  {title}{' '}
                  {showCount && (
                    <span className="page-count"> ({Number(count).toLocaleString('en-US')})</span>
                  )}{' '}
                  {tooltipText && (
                    <TooltipOverlay title={tooltipText}>
                      <InfoCircleSvg />
                    </TooltipOverlay>
                  )}
                </span>
              </Col>
            </Row>
            {description && (
              <Row className="">
                <p className="help-note m-0 float-start">{description}</p>
              </Row>
            )}
          </Row>
        </Col>
        {rightSection && (
          <Col
            xs={12}
            sm={6}
            className="d-flex justify-content-start justify-content-sm-end align-items-center mt-2 mt-sm-0"
          >
            {rightSection}
          </Col>
        )}
      </Row>
      {children}
    </div>
  );
}
